import { MessagePrimitive } from '@assistant-ui/react';
import { motion } from 'motion/react';

import { UserBubble } from '../bubble/UserBubble.tsx';
import { BranchPicker } from './BranchPicker.tsx';
import classes from './Thread.module.css';
import { UserActionBar } from './UserActionBar.tsx';

/**
 * Renders a user message in the chat thread with edit/branch navigation controls.
 *
 * Composes MessagePrimitive.Root from assistant-ui with UserBubble for content display,
 * UserActionBar for edit actions, and BranchPicker for navigating message branches.
 */
export function UserMessage() {
  return (
    <MessagePrimitive.Root className={classes.messageContainer} data-role="user">
      <div className={classes.contentWrapper}>
        <UserBubble />

        {/* Action bar wrapped in motion.div for hover animations */}
        <motion.div className={classes.userActionBar}>
          <UserActionBar />
        </motion.div>

        <BranchPicker />
      </div>
    </MessagePrimitive.Root>
  );
}
